import { render, staticRenderFns } from "./ieWorkspace.vue?vue&type=template&id=4f056718&scoped=true&"
import script from "./ieWorkspace.vue?vue&type=script&lang=js&"
export * from "./ieWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./ieWorkspace.vue?vue&type=style&index=0&id=4f056718&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f056718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f056718')) {
      api.createRecord('4f056718', component.options)
    } else {
      api.reload('4f056718', component.options)
    }
    module.hot.accept("./ieWorkspace.vue?vue&type=template&id=4f056718&scoped=true&", function () {
      api.rerender('4f056718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/detail/ieWorkspace.vue"
export default component.exports